import store from '../store'
import MailingModel from '../models/MailingModel'
import { dateToCompact } from '../helpers/filters'
import convert from 'xml-js'

export default class Mailing {
  constructor(api) {
    this.api = api
  }

  list_sending_mailings() {
    return this.api.call_busy({
      '_class': 'Mailing',
      '_method': 'list_sending_mailings',
    }).then(response => {
      console.log('Mailing.list_sending_mailings: ', response)
      const sendingMailings = {}
      sendingMailings.currMailings = response.mailing && (response.mailing.length && response.mailing || [response.mailing]) || []
      sendingMailings.lastMailings = response.last_mailing && (response.last_mailing.length && response.last_mailing || [response.last_mailing]) || []
      sendingMailings.upcoming = response.upcoming && (response.upcoming.length && response.upcoming || [response.upcoming]) || []

      store.commit('setSendingMailings', sendingMailings)
      return response
    })
  }

  load(id) {
    return this.api.call_busy({
      '_class': 'Mailing',
      '_method': 'load',
      'id': id,
    }).then(response => {
      const mMailing = new MailingModel().map(response)
      store.commit('setMailing', mMailing)
      store.commit('setBackMailing', { ...response.mailing._attributes})
    })
  }

  create() {
    const xml = this._parseMailingToXml()
    const mailing = store.getters.mailing
    if (mailing.folder_id) {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'create',
        'name': mailing.name,
        'xml': xml,
        'folder_id': mailing.folder_id,
      }).then(this._post_save(true))
    } else {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'create',
        'name': mailing.name,
        'xml': xml,
      }).then(this._post_save(true))
    }
  }

  _post_save(create) {
    return (response) => {
      let events = store.getters.getCampaignEvents
      let mailings = store.getters.getCampaignMailings
      const campaign_entries = { events, mailings }

      const mailing = new MailingModel().map(response)
      const mailEntry = {
        ...response.mailing._attributes,
        ...Object.assign({}, ...['dispatch_datetime', 'duplicates_allowed', '', 'from', 'subject', 'html_link', 'text_link'].map(a => ({[a]: response.mailing[a] && response.mailing[a]._text || ''})) )
      }
      if (create) {
        mailings.push(mailEntry)
      } else {
        mailings[mailings.findIndex((m) => m.id == mailing.id)] = mailEntry
      }
      store.commit('setMailing', mailing)
      store.commit('setBackMailing', { ...mailing})
      store.commit('setCampaignEntries', campaign_entries)
    }
  }

  update() {
    const mailing = store.getters.mailing
    const id = mailing.item
    const xml = this._parseMailingToXml()
    if (mailing.folder_id) {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'update',
        'id': id,
        'name': mailing.name,
        'xml': xml,
        'folder_id': mailing.folder_id,
      }).then(this._post_save(false))
    } else {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'update',
        'id': id,
        'name': mailing.name,
        'xml': xml,
      }).then(this._post_save(false))
    }
  }

  rename(id, name) {
    return this.api.call_busy({
      '_class': 'Mailing',
      '_method': 'update',
      'id': id,
      'name': name
    })
  }

  delete(id) {
    return this.api.call_busy({
      '_class': 'Mailing',
      '_method': 'delete',
      'id': id
    })
  }

  move(id, folder_id) {
    if (folder_id) {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'move',
        'id': id,
        'folder_id': folder_id
      })
    } else {
      return this.api.call_busy({
        '_class': 'Mailing',
        '_method': 'move',
        'id': id,
      })
    }
  }

  send_preview(params) {
    return this.api.call_busy(Object.assign({
      '_class': 'Mailing',
      '_method': 'send_preview'
    }, params))
  }

  // --- helpers
  
  _parseMailingToXml() {
    const mailing = store.getters.mailing
    let jsonObject = {
      request: {
        mailing: {
          _attributes: {
            name: mailing.name,
            status: mailing.status,
            lang: mailing.language,
          },
          // subject: '',
          // from: '',
          dispatch_datetime: dateToCompact(mailing.dispatch_datetime),
          duplicates_allowed: +mailing.duplicates_allowed,
          mail_template: {
            _attributes: {
              oid: mailing.mail_template ? mailing.mail_template.oid : 0
            },
          },
          unsubscribe_link: {
            _attributes: {
              oid: mailing.unsubscribe_link ? mailing.unsubscribe_link.oid : 0
            },
          },
          recipients: {
            recipient: [
            ]
          },
        }
      }
    }
    if (mailing.subject) {
      jsonObject.request.mailing.subject = mailing.subject
    }
    if (mailing.from) {
      jsonObject.request.mailing.from = mailing.from
    }
    mailing.recipients.forEach(recipient => {
      jsonObject.request.mailing.recipients.recipient.push({
        _attributes: {
          type: recipient.type,
          id: recipient.id
        }
      })
    })
    return convert.json2xml(jsonObject, {compact: true})
  }

}